import axios from "axios";

export function fetchDrives(params = {}) {
    return axios.get('/lsystem/api/v1/drives', {params: params})
}

export function fetchWaypoints(params = {}) {
    return axios.get('/lsystem/api/v1/way-point', {params: params})
}

export function fetchZones(params = {}) {
    // lsystem/api/v1/work-zone вместо admin/map/get-work-zones: admin/* закрывается под VPN
    return axios.get('/lsystem/api/v1/work-zone', {params: params})
}